import React from 'react';

const TiktokLogo = (props) => {
	return (
		<div class="tiktok_logo">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<path fill="#000000" d="M12.39,15.86c0.13,0,0.26,0.02,0.39,0.04v-3.14c-0.13-0.01-0.26-0.02-0.39-0.02C8.86,12.74,6,15.6,6,19.12c0,3.52,2.86,6.38,6.39,6.38s6.39-2.86,6.39-6.38v-8.63c1.04,1.58,2.8,2.54,4.7,2.54c0.17,0,0.35-0.01,0.52-0.03h0V9.5c-2.71-0.2-4.89-2.3-5.17-5h-3.01l-0.03,14.66c0,1.8-1.59,3.22-3.39,3.22c-1.8,0-3.26-1.46-3.26-3.26C9.13,17.32,10.59,15.86,12.39,15.86z"/>
			</svg>
		</div>
	)
}
export default TiktokLogo;